var SHRUNKEN_HEADER_CLASS = "shrunken-header";

AoPS.GoToHash = function (hash) {
	var cleanedHash = hash.substring(1).replace(/^([a-zA-Z0-9\-]*).*/, "$1");
	if (cleanedHash) {
		var hashedEl = $("#" + cleanedHash).length
			? $("#" + cleanedHash)
			: $("a[name=" + cleanedHash + "]");
		if (canNavResize && hashedEl.offset()) {
			var hashPosition = hashedEl.offset().top;
			if ($("#header").hasClass(SHRUNKEN_HEADER_CLASS)) {
				hashPosition -= $("#header").height();
			} else {
				hashPosition -= $("#header").height() * 2;
			}
			$("body,html").animate(
				{
					scrollTop: hashPosition,
				},
				300,
				"swing"
			);
		}
	}
};

var canNavResize = false;

var getWindowWidth = function () {
	return window.innerWidth;
};

var isMobile = function () {
	return window.matchMedia("(max-width: 700px)").matches;
};

// Menu mobile dropdown things

// Scrolling must be done after load
$(window).on("load", function () {
	if (window.location.hash) {
		try {
			var pos = $(window.location.hash);
			if (pos.length) {
				pos = pos.offset().top;
				if ($("#header").hasClass(SHRUNKEN_HEADER_CLASS)) {
					pos -= $("#header").height();
				} else {
					pos -= $("#header").height() * 2;
				}
				window.scrollTo(0, pos);
			}
		} catch (e) {
			// console.error(e);
		}
	}

	// hashchange can fire before load, so don't bind this event until then
	window.addEventListener("hashchange", function () {
		setTimeout(function () {
			AoPS.GoToHash(window.location.hash);
		}, 10);
	});
});

$(function () {
	var originalWindowWidth = getWindowWidth();
	var toggleLabel = function (labelEl) {
		var dropdown = $(labelEl).next().find(".dropdown-content");
		var menubar = $(labelEl).parent();
		var menuHeight = $(menubar).height();
		var dropdownHeight = $(dropdown).height();
		var newHeight = menuHeight;

		var extraBottomPadding = 6;
		if (menuHeight > dropdownHeight + 2 * extraBottomPadding) {
			newHeight = menuHeight - dropdownHeight - extraBottomPadding;
		} else {
			newHeight = menuHeight + dropdownHeight + extraBottomPadding;
		}
		$(menubar).height(newHeight);
	};
	var isDirectLink = (el) => el.classList.contains("menubar-label-direct-link");
	$(".menubar-label-link-outer").on("click", function (evt) {
		if (
			!isMobile() ||
			isDirectLink(evt.target) ||
			isDirectLink(evt.target.parentNode)
		) {
			return;
		} else {
			toggleLabel(this);
		}
	});

	$(window).on("resize", function (evt) {
		if (getWindowWidth() === originalWindowWidth) {
			return;
		}
		originalWindowWidth = getWindowWidth();
		if (!isMobile()) {
			$(".menubar-label").each(function (i) {
				$(this).height(16);
			});
			$(".menubar-labels").css({
				display: "flex",
				minHeight: 0,
				// eslint-disable-next-line no-dupe-keys
				// display: "-webkit-flex",
			});
			$(".menubar-labels").height("auto");
		} else {
			$(".menubar-labels").css({display: "none"});
			var bodyHeight = $("body").height();
			var headerHeight = $("#header-wrapper").height();
			$(".menubar-labels").height(bodyHeight - headerHeight);
			$(".menubar-label").each(function (i) {
				$(this).height("auto");
			});
		}
	});
	$(".menubar-hamburger").on("click", function (evt) {
		var bodyHeight = $("body").height();
		var headerHeight = $("#header-wrapper").height();
		if ($(".menubar-labels").css("display") === "none") {
			$(".menubar-labels").css({
				display: "block",
			});
			$(".menubar-labels").css({
				height: "auto",
				minHeight: bodyHeight - headerHeight + "px",
			});
		} else {
			$(".menubar-labels").css({display: "none"});
		}
	});

	$(".dropdown-content a").on("click", function (evt) {
		if (isMobile()) {
			$(".menubar-labels").css({display: "none"});
		}
	});

	$(".superuser").on("click", function (evt) {
		$.post(
			"/ajax.php",
			{
				action: "toggle-superuser",
			},
			function (data) {
				if (data.response && data.response.success) {
					AoPS.Ui.Flyout.display(
						"Sucessfully " +
							(data.response.superuser ? "enabled" : "disabled") +
							" superuser permissions."
					);

					$(".superuser").text(
						data.response.superuser ? "Disable Superuser" : "Enable Superuser"
					);
				} else {
					AoPS.Ui.Flyout.display(data.error_msg);
				}
			}
		);
	});

	// Shrinking top bar things

	var isScrolling = false;
	var isUserScroll = false;
	var header = $("#header");
	var headerWrapper = $("#header-wrapper");

	var adjustNavSize = _.throttle(
		_.bind(function () {
			if (isUserScroll) {
				isScrolling = false;
				isUserScroll = false;
				$("body,html").stop().animate();
			}
			var scrollPos = $(window).scrollTop();
			var isShrunken = header.hasClass(SHRUNKEN_HEADER_CLASS);
			if (scrollPos > 70 && !isShrunken) {
				headerWrapper.addClass("shrunken-header-wrapper");
				header.addClass(SHRUNKEN_HEADER_CLASS);
			} else if (scrollPos <= 0 && isShrunken) {
				headerWrapper.removeClass("shrunken-header-wrapper");
				header.removeClass(SHRUNKEN_HEADER_CLASS);
			}
		}, this),
		100
	);
	var body = $("body");
	var noNavResize =
		body.hasClass("community") ||
		body.hasClass("school-class-page") ||
		body.hasClass("mediawiki") ||
		body.hasClass("cart") ||
		body.hasClass("ebooks") ||
		body.hasClass("dashboard") ||
		body.hasClass("resources") ||
		body.hasClass("small-header") ||
		body.hasClass("no-nav-resize");

	if (!isMobile() && !noNavResize) {
		canNavResize = true;
		adjustNavSize();
		$("#header-wrapper").addClass("sticky");
		$(window).on("scroll", adjustNavSize);
	}
	// Not sure where this should go...
	// It makes the button scroll down the page to the callout section
	$("div.slide-button").on("click", function () {
		if (isScrolling) {
			return;
		}
		isScrolling = true;
		isUserScroll = false;
		var pos = $(".callouts-container").offset().top;
		if (!isMobile()) {
			pos -= 2 * $("#main-menubar").height();
		}

		$("body,html").animate(
			{
				scrollTop: pos,
			},
			1200,
			"swing",
			function () {
				isScrolling = false;
			}
		);
	});

	document.body.addEventListener("wheel", function () {
		isUserScroll = true;
	});

	$(window).on("resize", function (evt) {
		if (!isMobile() && !canNavResize && !noNavResize) {
			canNavResize = true;
			$(window).on("scroll", adjustNavSize);
		} else if (isMobile() && canNavResize) {
			canNavResize = false;
			$("#header").removeClass(SHRUNKEN_HEADER_CLASS);
			$(window).off("scroll", adjustNavSize);
		}
	});
});
